
import { motion } from 'framer-motion';
import { Book, BarChart2, HelpCircle, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useIsMobile } from '@/hooks/use-mobile';

const OtherResourcesSection = () => {
  const isMobile = useIsMobile();
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div 
      className="mt-6"
      variants={itemVariants}
    >
      <h2 className="text-2xl font-semibold mb-4 text-blue-700 flex items-center">
        <Book className="mr-2 h-6 w-6" />
        Muita tapoja saada tietoa
      </h2>
      
      <p className="text-gray-700 mb-5 text-sm md:text-base">
        Voit myös tutustua <a href="/artikkelit" className="text-blue-600 hover:underline font-medium">artikkeleihin</a> tai 
        vertailla eri <a href="/lainat/lainavertailu" className="text-blue-600 hover:underline font-medium">lainatuotteita</a> sivustollamme.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <a href="/artikkelit" className="group">
          <Card className="h-full transition-all duration-300 hover:shadow-md border border-blue-100 bg-white overflow-hidden hover:border-blue-300 hover:bg-blue-50">
            <CardContent className="p-4 flex flex-col items-center text-center">
              <div className="bg-blue-100 p-3 rounded-full mb-3 group-hover:bg-blue-600 transition-colors duration-300">
                <Book className="h-5 w-5 text-blue-600 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-medium text-base mb-2 text-blue-700 group-hover:text-blue-600 transition-colors">Artikkelit</h3>
              <p className="text-gray-600 text-sm">Lue hyödyllisiä artikkeleja raha-asioista ja lainoista</p>
              <div className="mt-3 text-blue-600 flex items-center text-sm font-medium">
                Lue lisää <ExternalLink className="ml-1 h-3 w-3" />
              </div>
            </CardContent>
          </Card>
        </a>
        
        <a href="/lainat/lainavertailu" className="group">
          <Card className="h-full transition-all duration-300 hover:shadow-md border border-blue-100 bg-white overflow-hidden hover:border-blue-300 hover:bg-blue-50">
            <CardContent className="p-4 flex flex-col items-center text-center">
              <div className="bg-blue-100 p-3 rounded-full mb-3 group-hover:bg-blue-600 transition-colors duration-300">
                <BarChart2 className="h-5 w-5 text-blue-600 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-medium text-base mb-2 text-blue-700 group-hover:text-blue-600 transition-colors">Lainojen vertailu</h3>
              <p className="text-gray-600 text-sm">Vertaile eri lainatuotteita ja löydä itsellesi sopivin</p>
              <div className="mt-3 text-blue-600 flex items-center text-sm font-medium">
                Vertaile nyt <ExternalLink className="ml-1 h-3 w-3" />
              </div>
            </CardContent>
          </Card>
        </a>
        
        <a href="/ukk" className="group">
          <Card className="h-full transition-all duration-300 hover:shadow-md border border-blue-100 bg-white overflow-hidden hover:border-blue-300 hover:bg-blue-50">
            <CardContent className="p-4 flex flex-col items-center text-center">
              <div className="bg-blue-100 p-3 rounded-full mb-3 group-hover:bg-blue-600 transition-colors duration-300">
                <HelpCircle className="h-5 w-5 text-blue-600 group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="font-medium text-base mb-2 text-blue-700 group-hover:text-blue-600 transition-colors">UKK</h3>
              <p className="text-gray-600 text-sm">Tutustu usein kysyttyihin kysymyksiin</p>
              <div className="mt-3 text-blue-600 flex items-center text-sm font-medium">
                Katso vastaukset <ExternalLink className="ml-1 h-3 w-3" />
              </div>
            </CardContent>
          </Card>
        </a>
      </div>
      
      <div className="mt-6 text-center">
        <a 
          href="/kilpailuta" 
          className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-colors font-medium shadow-md hover:shadow-lg text-sm"
        >
          Vertaile lainatarjouksia nyt
        </a>
      </div>
    </motion.div>
  );
};

export default OtherResourcesSection;
